export default __webpack_public_path__ + "static/media/JULY2022.ede8090a.png";